export enum ReportType {
    ANNUAL = 'annual',
    QUARTERLY = 'quarterly',
    MONTHLY = 'monthly',
    CUSTOM = 'custom',
}
